module.exports = __webpack_public_path__ + "static/media/car-5.28872203.jpg";